var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { styled } from '@mui/material/styles';
import { AccountHeader } from '..';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
export const AccountAccordion = styled((props) => _jsx(Accordion, Object.assign({}, props)))(({ theme }) => ({
    '&.Mui-expanded': {
        marginTop: theme.spacing(1),
        marginBottom: 0,
    },
}));
export const AccountAccordionSummary = styled((_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (_jsx(AccordionSummary, Object.assign({}, props, { expandIcon: _jsx(ExpandMoreIcon, { fontSize: 'large' }) }, { children: _jsx(AccountHeader, { children: children }) })));
})(({ theme }) => {
    var _a;
    return ({
        borderBottom: '3px solid',
        borderBottomColor: (_a = theme.account) === null || _a === void 0 ? void 0 : _a.navigation.background,
    });
});
export const AccountAccordionDetails = styled((props) => _jsx(AccordionDetails, Object.assign({}, props)))(({ theme }) => ({
    marginTop: theme.spacing(1),
}));
